import { Component, effect, signal, CreateEffectOptions, input, output, inject } from '@angular/core';
import { ChartsModule, SeriesClickEvent } from '@progress/kendo-angular-charts';
import { BaseComponent } from '../../../../../../../core/shared/common/base.component';
import { TopFiveData } from '../../../../../../../core/services/analytics.service';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { CommonModule } from '@angular/common';
import { ChartLabelsPopupService } from '../../../../../../../core/shared/common/chart-labels-popup.service';
import { SuspectedDetailsService } from '../sla-adherence/services/suspectusersdetails.service';
import { ExcelModule, GridDataResult, GridModule } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../../environments/environment';
import { DialogsModule } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-suspect-users',
  standalone: true,
  imports: [ChartsModule, LoaderModule, CommonModule, GridModule, DialogsModule, ExcelModule],
  templateUrl: './suspect-users.component.html',
  styleUrls: ['./suspect-users.component.scss'],
  providers: [SuspectedDetailsService],
})
export class SuspectUsersComponent extends BaseComponent {
  public popupService = inject(ChartLabelsPopupService);
  public gridService = inject(SuspectedDetailsService);

  public topSuspectUsersData = input<TopFiveData[]>([]);
  public topUserDetailData = input<TopFiveData[]>([]);
  public seriesClick = output<SeriesClickEvent>();

  public isLoading = signal(true);
  public ticketsByUser = signal<TopFiveData[]>([]);
  public ticketsByEventName = signal<TopFiveData[]>([]);
  public organizationId = input<number | null>();
  public dateRange = input<string[] | null>(null);
  public showPopup = false;

  constructor() {
    super();
    this.initEffect();
  }

  private initEffect() {
    effect(
      () => {
        const suspectUsersData = this.topSuspectUsersData();
        const userDetailData = this.topUserDetailData();
        if (suspectUsersData && userDetailData) {
          this.ticketsByUser.set(suspectUsersData.slice(0, 5) || []);
          this.ticketsByEventName.set(userDetailData.slice(0, 5) || []);
          this.isLoading.set(false);
        } else {
          this.ticketsByUser.set([]);
          this.ticketsByEventName.set([]);
          this.isLoading.set(true);
        }
      },
      { allowSignalWrites: true } as CreateEffectOptions
    );
  }

  public handleSeriesClick(event: SeriesClickEvent): void {
    this.seriesClick.emit(event);
  }

  truncateCategoryLabel(args: any): string {
    const label = args.text;
    const maxLength = 20; // Set your desired max length
    return label.length > maxLength ? label.substring(0, maxLength) + '...' : label;
  }

  onContextMenuSelect(event: any) {
    if (event?.text === 'View Data') {
      this.gridService.setDateRange(this.dateRange());
      this.gridService.url = `${environment.apiUrl}/v1/analytics/administrative/slaviolationsdetails(${this.organizationId()})`;
      this.gridService.read();
      this.showPopup = true;
    } else {
      console.warn('Invalid event structure:', event);
    }
  }

  public allData = (): Observable<GridDataResult> => {
    return this.gridService.queryAll();
  };

  // Close popup
  close() {
    this.showPopup = false;
  }
}
